module.exports = __webpack_public_path__ + "img/36.929f9768.png";